"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEAPON_TEXTURE_MAPPING = exports.WEAPON_TYPE_TO_CLASS_MAPPING = exports.WeaponClass = exports.WeaponType = void 0;
/**
 * Types of weapon
 */
var WeaponType;
(function (WeaponType) {
    WeaponType["Sword"] = "sword";
    WeaponType["Dagger"] = "dagger";
    WeaponType["Staff"] = "staff";
})(WeaponType || (exports.WeaponType = WeaponType = {}));
/**
 * A class of weapon
 */
var WeaponClass;
(function (WeaponClass) {
    WeaponClass["Sword"] = "sword";
    WeaponClass["Dagger"] = "dagger";
    WeaponClass["Staff"] = "staff";
})(WeaponClass || (exports.WeaponClass = WeaponClass = {}));
exports.WEAPON_TYPE_TO_CLASS_MAPPING = (_a = {},
    _a[WeaponType.Sword] = WeaponClass.Sword,
    _a[WeaponType.Dagger] = WeaponClass.Dagger,
    _a[WeaponType.Staff] = WeaponClass.Staff,
    _a);
/**
 * Maps the weapon to its possible textures
 */
exports.WEAPON_TEXTURE_MAPPING = (_b = {},
    _b[WeaponType.Sword] = ["hero"],
    _b[WeaponType.Dagger] = ["rogue"],
    _b[WeaponType.Staff] = ["mage"],
    _b);
